import { useQuery } from "@apollo/client";
import { List, ListItem, ListItemText } from "@material-ui/core";
import {
  AccountCircleOutline,
  CalculatorVariantOutline,
  CreditCardOutline,
  FileOutline,
  NoteTextOutline,
} from "mdi-material-ui";
import * as React from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";

import { GetNavigationDataDocument } from "../../../generated/graphql";
import useMobile from "../../../hooks/useMobile";
import CollapsableMenuItem from "../../dashboard/components/CollapsableMenuItem";
import { formatDateStringToDate } from "../util/date.util";

const Container: React.FunctionComponent = () => {
  const { isMobile } = useMobile();

  const { push } = useHistory();
  const { pathname } = useLocation();
  const { id, fokoid } = useParams<{ id: string; fokoid: string }>();
  const akteQuery = useQuery(GetNavigationDataDocument, {
    skip: id == null || id === "create",
    variables: { akteId: id || "", fokoId: fokoid || "" },
  });

  if (!akteQuery.data?.akte) {
    return null;
  }
  const akte = akteQuery.data.akte;
  const foko = akteQuery.data.foko;

  return (
    <List
      dense={!isMobile}
      component="nav"
      aria-labelledby="nested-list-subheader"
      subheader={
        <ListItem>
          <ListItemText
            id="nested-list-subheader"
            primary={`Akte: ${akte.title}`}
            primaryTypographyProps={{ noWrap: true }}
            secondary={`Forderungskonto erstellt am ${formatDateStringToDate(
              foko.date
            )}`}
          />
        </ListItem>
      }
    >
      <CollapsableMenuItem
        label={"Aufstellung"}
        icon={<CalculatorVariantOutline />}
        key={"overview"}
        onClick={() => {
          push(`/dashboard/akten/${id}/fokos/${fokoid}`);
        }}
        selected={pathname
          .toLowerCase()
          .endsWith(`/dashboard/akten/${id}/fokos/${fokoid}`)}
      />
      <CollapsableMenuItem
        label={"Forderungen"}
        icon={<FileOutline />}
        key={"forderungen"}
        onClick={() => {
          push(`/dashboard/akten/${id}/fokos/${fokoid}/forderungen`);
        }}
        selected={pathname
          .toLowerCase()
          .includes(`/dashboard/akten/${id}/fokos/${fokoid}/forderungen`)}
      />
      <CollapsableMenuItem
        label={"Buchungen"}
        icon={<CreditCardOutline />}
        key={"buchungen"}
        onClick={() => {
          push(`/dashboard/akten/${id}/fokos/${fokoid}/buchungen`);
        }}
        selected={pathname
          .toLowerCase()
          .includes(`/dashboard/akten/${id}/fokos/${fokoid}/buchungen`)}
      />
      <CollapsableMenuItem
        label={"Beschreibungen"}
        icon={<NoteTextOutline />}
        key={"beschreibungen"}
        onClick={() => {
          push(`/dashboard/akten/${id}/fokos/${fokoid}/comments`);
        }}
        selected={pathname
          .toLowerCase()
          .includes(`/dashboard/akten/${id}/fokos/${fokoid}/comments`)}
      />
      <CollapsableMenuItem
        label={"Gläubiger"}
        icon={<AccountCircleOutline />}
        key={"glaeubiger"}
        onClick={() => {
          push(`/dashboard/akten/${id}/fokos/${fokoid}/glaeubiger`);
        }}
        selected={pathname
          .toLowerCase()
          .includes(`/dashboard/akten/${id}/fokos/${fokoid}/glaeubiger`)}
      />
      <CollapsableMenuItem
        label={"Schuldner"}
        icon={<AccountCircleOutline />}
        key={"schuldner"}
        onClick={() => {
          push(`/dashboard/akten/${id}/fokos/${fokoid}/schuldner`);
        }}
        selected={pathname
          .toLowerCase()
          .includes(`/dashboard/akten/${id}/fokos/${fokoid}/schuldner`)}
      />
    </List>
  );
};

export default Container;
